import React, { ReactNode, useState } from 'react';

import { SectionProps } from '@/components/section';

export interface ISectionContextProps {
  sectionProps?: SectionProps;
  children?: ReactNode | undefined;
}

export const SectionContext = React.createContext<ISectionContextProps>({
  sectionProps: {},
});

export const SectionContextProvider: React.FC<ISectionContextProps> = (
  props
) => {
  const [sectionProps] = useState(props.sectionProps);

  return (
    <SectionContext.Provider
      value={{
        sectionProps,
      }}
    >
      {props.children}
    </SectionContext.Provider>
  );
};
